import { useState, useCallback } from 'react';

/**
 * Manages open/close boolean state — ideal for modals, dropdowns, drawers.
 *
 * @param {boolean} defaultOpen
 * @returns {{ isOpen: boolean, open: Function, close: Function, toggle: Function }}
 */
const useDisclosure = (defaultOpen = false) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((prev) => !prev), []);

  return { isOpen, open, close, toggle };
};

export default useDisclosure;
